import { apiRequest } from "../utils/useAPIRequest";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import constant from "../utils/constant";
import { subscriptionStore } from "../stores";
import { queryClient } from "../App";
import moment from "moment";

const useGetSubscriptions = (
  subscriptionTableQuery,
  filterQuery,
  searchQuery
) => {
  const query = useMemo(() => {
    if (searchQuery) {
      return `${subscriptionTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${subscriptionTableQuery}&${filterQuery}`;
    } else {
      return subscriptionTableQuery;
    }
  }, [filterQuery, subscriptionTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["subscription", query],
    queryFn: () => {
      return apiRequest({
        url: `/subscriptions?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const subscriptionAnalysis = async () => {
  const { status, data, errorMessage } = await apiRequest({
    url: `/subscriptions/analysis`,
    method: "get",
  });

  if (status === constant.Success) {
    subscriptionStore.setSubscriptionAnalysis(data);
    return { status: constant.Success };
  }
  return { errorMessage, status };
};

const giveSubscription = async (payload) => {
  const { status, errorMessage } = await apiRequest({
    url: "/subscriptions/admin/subscribe",
    method: "post",
    payload: payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({ queryKey: ["subscription"] });
    return { status };
  }
  return { status, errorMessage };
};

export default {
  useGetSubscriptions,
  subscriptionAnalysis,
  giveSubscription,
};
